import React from "react";
import { useWallet } from "../../context/WalletContext";
import Button from "../common/Button";
import { LOGO_MARK } from "../../config/assets";

// Shown when connected to the wrong chain. Auto-switch already fired once;
// this gives the user a manual retry. No page reload happens here.
export default function WrongNetwork() {
  const { switchNetwork, switching } = useWallet();
  return (
    <div className="net-overlay">
      <img src={LOGO_MARK} alt="Nexaura" style={{ width: 64, opacity: 0.9 }} />
      <h3>Switch Network</h3>
      <p>
        Your wallet is on a different network. Approve the switch in your wallet to
        continue using Nexaura.
      </p>
      <Button loading={switching} onClick={switchNetwork} className="" variant="blue">
        {switching ? "Switching…" : "Switch Network"}
      </Button>
    </div>
  );
}
